import type {Banner} from '../../types';

import {cn} from '@ds/helpers';
import {Autoplay, FreeMode, Navigation, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import {sendDataToLighthouse} from 'utils/sendDataToLighthouse';

type BannerCarouselProps = {
  banners: Banner[];
};

const BannerCarousel: React.FC<BannerCarouselProps> = ({banners}) => {
  if (!banners.length) {
    return null;
  }

  return (
    <section
      className="relative min-h-32.5 w-full cursor-pointer p-3.5 mb-2"
      aria-label="بنرهای پیشنهادی"
    >
      <Swiper
        slidesPerView={1}
        spaceBetween={8}
        centeredSlides={banners.length > 1}
        loop={banners.length > 1}
        autoplay={{delay: 5000, disableOnInteraction: false}}
        pagination={banners.length > 1 ? {clickable: true} : false}
        modules={[Autoplay, Pagination, Navigation, FreeMode]}
        className={cn(
          'absolute! inset-0! w-full! p-3.5!',
          '[--swiper-pagination-bullet-inactive-color:var(--color-white)]',
          '[--swiper-pagination-bullet-inactive-opacity:0.36]',
          '[--swiper-pagination-color:var(--color-white)]',
          '[&_.swiper-pagination-horizontal]:left-1/2! [&_.swiper-pagination-horizontal]:flex',
          '[&_.swiper-pagination-horizontal]:h-3.5 [&_.swiper-pagination-horizontal]:w-fit!',
          '[&_.swiper-pagination-horizontal]:-translate-x-1/2 [&_.swiper-pagination-horizontal]:items-center',
          '[&_.swiper-pagination-horizontal]:justify-center [&_.swiper-pagination-horizontal]:rounded-lg',
          '[&_.swiper-pagination-horizontal]:bg-black/50 [&_.swiper-pagination-horizontal]:px-1'
        )}
      >
        {banners.map((banner) => (
          <SwiperSlide className="overflow-hidden rounded-md" key={banner.id}>
            <button
              type="button"
              className="block h-full w-full overflow-hidden rounded-md"
              aria-label={`مشاهده ${banner.file_name}`}
              onClick={() => {
                sendDataToLighthouse({action_name: 'homeBannerClick'});
                if (banner.link) {
                  window.open(banner.link, '_blank', 'noopener,noreferrer');
                }
              }}
            >
              <img
                className="block h-full w-full object-fill"
                alt={banner.file_name}
                src={banner.cdn}
              />
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default BannerCarousel;
